import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=33945eb3&"
import script from "./BasePage.js?vue&type=script&lang=js&"
export * from "./BasePage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33945eb3')) {
      api.createRecord('33945eb3', component.options)
    } else {
      api.reload('33945eb3', component.options)
    }
    module.hot.accept("./BasePage.vue?vue&type=template&id=33945eb3&", function () {
      api.rerender('33945eb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/BasePage/BasePage.vue"
export default component.exports